module.exports = __webpack_public_path__ + "./Youhua_cf11a7ff0951f650a722985b2c11ae30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Youhua.jpg
// module id = 544
// module chunks = 0